import '../class/nav.js';
import { UtmParams } from "global/js/Classes/UtmParams";
import { ButtonAnchor } from "general/js/anchor";
import { ratesSection } from 'general/js/section-rates';
import PopupHandler from "global/js/Classes/PopupHandler";

new PopupHandler(
    '/nt/form',
    'talks-popup-baselinker',
    'pop-up-baselinker',
    true,
    '',
    4
).init()

const utmParams =  new UtmParams(
    {'source': 'baselinker_lp', 'campaign': 'b2b_baselinker'},
    [window.location.origin]
)

document.addEventListener('DOMContentLoaded', function(){

    ratesSection();
    utmParams.set();

    const bs = new ButtonAnchor({
        selector: '.js-scroll-to-target',
        target: '#clause-section',
        excludeHeader: true,
        speed: 300,
        offset: 0
    });

}, false);

